var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTranslateIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.973 15.5L11.986 6.38393L15 15.5M9.983 12.4438H13.976M1 3.07252H11.516M6.258 1.5V2.94604M4.32 5.41535C4.91595 6.44349 5.57775 7.42005 6.3 8.33705M6.3 8.33705C6.89477 9.09316 7.52927 9.80742 8.2 10.4759M6.3 8.33705C5.23448 9.88336 4.01083 11.2793 2.655 12.4951M6.3 8.33705C7.41405 6.72094 8.34629 4.95237 9.075 3.07252",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTranslateIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/translate_icon.29564c77660623f0203fe812ad47f1b7.svg";